<ion-content class="ion-padding" [scrollY]="true" [forceOverscroll]="true">
  <ion-refresher slot="fixed" (ionRefresh)="reload($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <ion-toolbar>
    <ion-title>{{ 'ENERGY_WALLET.TITLE' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="closeMe()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ng-container *ngIf="wallet as data; else stateTemplate">
    <ion-card class="wallet-card wallet-summary-card">
      <ion-card-header>
        <ion-card-subtitle>{{ 'ENERGY_WALLET.AVAILABLE' | translate }}</ion-card-subtitle>
        <ion-card-title class="summary-value">{{ formatKwh(data.availableWh) }}</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <ion-text color="medium">
          <p class="ion-no-margin">{{ 'ENERGY_WALLET.DESCRIPTION' | translate }}</p>
        </ion-text>
      </ion-card-content>
    </ion-card>

    <ion-card class="wallet-card">
      <ion-list lines="inset">
        <ion-item>
          <ion-icon name="battery-charging-outline" slot="start" color="primary"></ion-icon>
          <ion-label>
            <p>{{ 'ENERGY_WALLET.BALANCE' | translate }}</p>
            <h3>{{ formatKwh(data.wallet?.balanceWh) }}</h3>
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-icon name="flash-outline" slot="start" color="medium"></ion-icon>
          <ion-label>
            <p>{{ 'ENERGY_WALLET.RESERVED' | translate }}</p>
            <h3>{{ formatKwh(data.wallet?.reservedWh) }}</h3>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-card>

    <ion-card class="wallet-card">
      <ion-card-header>
        <ion-card-title class="section-title">
          <ion-icon name="wallet-outline"></ion-icon>
          {{ 'ENERGY_WALLET.CREDIT_LOTS' | translate }}
        </ion-card-title>
      </ion-card-header>
      @if (data.activeLots?.length) {
      <ion-list lines="inset">
        @for (lot of data.activeLots; track trackLot($index, lot)) {
        <ion-item>
          <ion-icon name="flash-outline" slot="start" color="primary"></ion-icon>
          <ion-label class="ion-text-wrap">
            <h2>{{ formatKwh(lot.remainingWh) }}</h2>
            <p>{{ lot.reason || ('ENERGY_WALLET.CREDIT_REASON_FALLBACK' | translate) }}</p>
            <p>{{ 'ENERGY_WALLET.PAID_BY' | translate }}: {{ creditLotPayerLabel(lot) }}</p>
            <p>{{ sourceTypeLabel(lot.sourceType) }}</p>
          </ion-label>
        </ion-item>
        }
      </ion-list>
      } @else {
        <ng-container *ngTemplateOutlet="noLotsTemplate"></ng-container>
      }
    </ion-card>

    <ion-card class="wallet-card">
      <ion-card-header>
        <ion-card-title class="section-title">
          <ion-icon name="swap-vertical-outline"></ion-icon>
          {{ 'ENERGY_WALLET.MOVEMENTS' | translate }}
        </ion-card-title>
      </ion-card-header>
      @if (movements.length) {
      <ion-list lines="inset">
        @for (movement of movements; track trackMovement($index, movement)) {
        <ion-item>
          <ion-icon name="swap-vertical-outline" slot="start" [color]="movementColor(movement.type)"></ion-icon>
          <ion-label class="ion-text-wrap">
            <h2>
              {{ formatSignedKwh(movement.quantityWh) }}
              <ion-badge [color]="movementColor(movement.type)">
                {{ movementTranslationKey(movement.type) | translate }}
              </ion-badge>
            </h2>
            <p>{{ movementReason(movement) }}</p>
            <p>{{ movement.createdAt | date:'short' }}</p>
          </ion-label>
          <ion-note slot="end" *ngIf="movement.coveredAmount">
            {{ movement.coveredAmount | number:'1.2-2' }} {{ movement.currency }}
          </ion-note>
        </ion-item>
        }
      </ion-list>
      } @else {
        <ng-container *ngTemplateOutlet="noMovementsTemplate"></ng-container>
      }
    </ion-card>
  </ng-container>

  <div class="safe-bottom"></div>
</ion-content>

<ng-template #stateTemplate>
  <ion-card>
    <ion-card-content class="ion-text-center">
      <ion-spinner *ngIf="loading"></ion-spinner>
      <ng-container *ngIf="!loading && error">
        <ion-icon name="alert-circle-outline" color="danger"></ion-icon>
        <p>{{ 'ENERGY_WALLET.LOAD_ERROR' | translate }}</p>
        <ion-button fill="outline" size="small" (click)="reload()">
          {{ 'ENERGY_WALLET.REFRESH' | translate }}
        </ion-button>
      </ng-container>
    </ion-card-content>
  </ion-card>
</ng-template>

<ng-template #noLotsTemplate>
  <ion-list lines="none">
    <ion-item>
      <ion-icon name="flash-off-outline" slot="start" color="medium"></ion-icon>
      <ion-label color="medium">{{ 'ENERGY_WALLET.NO_CREDIT_LOTS' | translate }}</ion-label>
    </ion-item>
  </ion-list>
</ng-template>

<ng-template #noMovementsTemplate>
  <ion-list lines="none">
    <ion-item>
      <ion-icon name="receipt-outline" slot="start" color="medium"></ion-icon>
      <ion-label color="medium">{{ 'ENERGY_WALLET.NO_MOVEMENTS' | translate }}</ion-label>
    </ion-item>
  </ion-list>
</ng-template>
